<template>
    <div class="fixed w-full px-8 py-4 -ml-8 z-10 font-medium font-600 font-frank text-base bg-gray-200">
        <slot />
    </div>
</template>